module.exports = __webpack_public_path__ + "img/pla_LZDVN.f846e8de.png";